import http from '../../../Utils/http';

const OrganizationOwnerUpdate = {
  name: 'organizationOwnerUpdate',
  state: {
    organizationLoading: false,
    error: '',
    organizationMessage: '',
  },
  reducers: {
    organizationUpdateRequested(state) {
      return {
        ...state,
        organizationLoading: true,
        error: '',
        organizationMessage: '',
      };
    },
    organizationUpdateReceived(state, payload) {
      return {
        ...state,
        organizationLoading: false,
        organizationMessage: 'Organization owner updated successfully.',
        error: '',
      };
    },
    organizationUpdateRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        organizationMessage: '',
        organizationLoading: false,
      };
    },
    clearStatus(state) {
        return {
          ...state,
          error: '',
          organizationMessage: '',
        };
      }
  },
  effects: (dispatch) => ({
    async requestForOrganizationUpdate(data) {
      try {
        this.organizationUpdateRequested();
        const { userId, orgId } = data;
        const response = await http.put(`savvy/organization/setOrganizationOwner/${userId}/${orgId}`);
        this.organizationUpdateReceived(response.data.message);
      } catch (err) {
        this.organizationUpdateRequestFailed(err.response?.data?.error || 'Something went wrong');
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Failed to update organization owner',
            open: true,
          },
        });
      }
    },
    async clearData() {
      this.clearStatus();
    },
  }),
};

export default OrganizationOwnerUpdate;
